document.addEventListener('DOMContentLoaded', () => {

    const hero = document.querySelector('.hero-sticky')
    
    if( hero && !hero.classList.contains('is-cover') ) {
    
        let breakpoints = hero.dataset.sizes ?? []
    
        breakpoints = JSON.parse(breakpoints)
    
        function getClosestBreakpoint(width) {
    
            let breakpoints = hero.dataset.sizes ?? []
    
            breakpoints = JSON.parse(breakpoints)
    
            const breakpoint = 991
    
            const pointToCheck = window.innerWidth > breakpoint ? 'desktop' : 'mobile'
    
            if(pointToCheck === 'desktop') {
                breakpoints = breakpoints.filter(b => b.width > breakpoint)
            }
    
            else {
                breakpoints = breakpoints.filter(b => b.width <= breakpoint)
            }
    
            return breakpoints.reduce((prev, curr) =>
                Math.abs(curr.width - width) < Math.abs(prev.width - width) ? curr : prev
            );
        }
    
        window.addEventListener('resize', () => {
            if( breakpoints.length === 0 ) return
            const closest = getClosestBreakpoint(window.innerWidth)
            hero.style['aspect-ratio'] = closest.ratio
        });
    
    
        const initialClosest = getClosestBreakpoint(window.innerWidth);
    
        hero.style['aspect-ratio'] = initialClosest.ratio
    
    }

})
